const global = window

inputs.alias.bool = 'boolean'
inputs.alias.switch = 'boolean'
inputs.alias.checkboxSwitch = 'boolean'

inputs.types.boolean = function (data, name, niceName, type, input, parent, inputWindow) {
    /* input.lc_switch(
        data.on ? data.on : 'Oui',
        data.off ? data.off : 'Non'
    )*/ 
    return data
}
